export default {
  ACTIVE: "فعال",
  INACTIVE: "غیرفعال",
  FUND_FIXED_INCOME: "درآمد ثابت",
  FUND_EQUITY: "سهامی",
  FUND_BALANCED: "مختلط",
  WEEKLY: "هفتگی",
  DAILY: "روزانه",
  MONTHLY: "ماهانه",
  SUCCEED: "فعال",
  FAILED: "ناموفق",
  CANCELED: "لغوشده",
  FAILED_TO_ACCESS_BANK: "عدم ارتباط با بانک",
  INIT: "شروع‌شده",
  PENDING: "در انتظار",
  DONE: "موفق",
  FUND: "صندوق",
  TOKEN: "رمزارز",
  INITIATED: "شروع‌شده",
  SUCCESS: "موفق",
  BUY: "خرید",
  SELL: "ابطال",
  CREATED: "پیش‌نویس",
  APPROVED: "تایید",
  UNKNOWN: "نامعلوم",
  DELETED: "حذف‌شده",
  PAID: "پرداخت‌شده",
  REFUNDED: "برگشت‌داده‌شده",
  SETTLED: "تسویه‌شده",
  CANCEL: "ناموفق",
  DEBIT: "بدهکار",
  CREDIT: "بستانکار",
  CHARGE: "پس‌انداز آنی",
  DIRECT_DEBIT: "پس‌انداز خودکار",
  CASHOUT: "برداشت",
  REVOKE: "ابطال",
  GIFT: "هدیه",
  ROUNDUP: "گرد کردن",
  CORPORATION: "پرداخت‌شده",
  REFUND: "برگشت پول",
  PURCHASE: "خرید",
  SETTLEMENT: "تسویه",
  AUTO_PURCHASE: "خرید خودکار",
  BONUS: "هدیه",
  Male: "مرد",
  Female: "زن",
  PROFIT: "دوره ای",
  PENDING_VERIFY: "در انتظار تایید",
  MANUAL: "دستی",
  AUTOMATIC: "خودکار",
  BALOOT: "بلوط",
  OTHER: "دیگر",
};
